// extracted by mini-css-extract-plugin
export default {"container":"inforCard_container__w9BaI","imagePlaceholder":"inforCard_imagePlaceholder__zQSTf","heading":"inforCard_heading__iRoxS","subHeading":"inforCard_subHeading__8I5XJ"};